export const OrderParameterId = {
    Descending: 0,
    Ascending: 1
};

export const OrderParameter = {
    Descending: "Descending",
    Ascending: "Ascending"
};
